import axios from "./axios-handler.service";
const BASE_URL = "/api/Eventos";

export interface Evento {
  idEvento: string;
  idConsultor: number;
  acao: string;
  comando: string;
  dataCriacao: string;
  dataRecebimento: string;
  dataProcessamento: string;
  erroProcessamento: string;
}
export interface FiltrosEvento {
  dataDe: string;
  dataAte: string;
  idConsultor: string;
  apenasComErro: boolean;
  offset: number;
  limit: number;
  order?: string;
}
export class EventosService {
  static async obter(idEvento: number): Promise<Evento> {
    const response = await axios.get(`${BASE_URL}/Obter`, {
      params: { idEvento },
    });
    return response.data;
  }
  static async listar(filtro: FiltrosEvento): Promise<Evento[]> {
    const {
      dataDe,
      dataAte,
      idConsultor,
      apenasComErro,
      offset,
      limit,
      order,
    } = filtro;
    const response = await axios.get(`${BASE_URL}/Listar`, {
      params: {
        dataDe,
        dataAte,
        idConsultor,
        apenasComErro,
        offset,
        limit,
        order,
      },
    });
    return response.data;
  }
  static async marcarComoPendente(idEvento: string): Promise<void> {
    const response = await axios.post(`${BASE_URL}/MarcarComoPendente`, {
      idEvento,
    });
    return response.data;
  }
  static async ignorarRegistro(idEvento: string): Promise<void> {
    const response = await axios.post(`${BASE_URL}/IgnorarRegistro`, {
      idEvento,
    });
    return response.data;
  }
}
